import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight, MapPin } from "lucide-react";
import ServiceAreaMap from "../ServiceAreaMap";
import { BUSINESS } from "../../data/business";

// "Where we work" — split layout: copy + CTAs on the LEFT, interactive map on the RIGHT.
// Two CTAs: primary Call (orange) and secondary "All service areas" (outline).
export default function ServiceMapSection() {
  return (
    <section className="py-14 md:py-20" data-testid="home-service-map">
      <div className="abc-container grid lg:grid-cols-12 gap-10 lg:gap-12 items-center">
        <div className="lg:col-span-5">
          <div className="text-xs font-bold uppercase tracking-widest text-[#54616E] mb-3">Where we work</div>
          <h2 className="font-display text-3xl sm:text-4xl font-extrabold text-[#1A1D21] leading-tight">
            Serving the Baltimore &amp; <span className="text-[#E31D2B]">DC</span> metros
          </h2>
          <p className="mt-4 text-slate-600 leading-relaxed">
            We're a service-area business covering two Maryland metros — Baltimore and Temple Hills / DC — and the communities around each. Click a city pin on the map to explore that area, or jump to the full list.
          </p>

          <div className="mt-6 flex flex-wrap items-center gap-3">
            <a href={BUSINESS.phoneHref} className="abc-btn abc-btn-accent" data-testid="map-call-cta">
              <Phone className="w-4 h-4" /> Call {BUSINESS.phone}
            </a>
            <Link to="/service-areas" className="abc-btn abc-btn-outline" data-testid="home-view-areas">
              All service areas <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="mt-6 flex items-center gap-2 text-sm text-slate-500">
            <MapPin className="w-4 h-4 text-[#54616E]" /> Two local crews · Baltimore &amp; Temple Hills / DC
          </div>
        </div>

        <div className="lg:col-span-7">
          <ServiceAreaMap />
        </div>
      </div>
    </section>
  );
}
